import { useContext } from "react";
import { Grid, Heading, Paragraph, BackButton } from "capitalrx-components-2.0";
import cn from "classnames";
import styles from "./Error.module.scss";
import { ThemeSelectorContext } from "@/context/index";

interface Props {
  type: string;
}

const ErrorMessageBody = ({ type }: Props): JSX.Element => {
  const { H2, H3 } = Heading;
  const { client } = useContext(ThemeSelectorContext);

  const backButtonClassName = cn({
    [styles.RejectBack]: type === "reject",
    [styles.WhitelabelButton]: !!client,
  });

  if (type === "reject") {
    return (
      <>
        <H3 roboto>Your request cannot be processed at this time.</H3>
        <div className={styles.ErrorDescription}>
          <div className={styles.ErrorDescriptionReject}>
            <Paragraph>There are two common causes of this:</Paragraph>
            <ul className={styles.ErrorDescriptionList}>
              <li>The drug entered is not eligible for discounts under the Advantage program.</li>
              <li>The quantity exceeds the limits on this medication.</li>
            </ul>
            <Paragraph>If you would like to try again, please change the drug or adjust the quantity.</Paragraph>
            <BackButton classNames={backButtonClassName} tier="primary" text="Go Back" />
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className={styles.ErrorContainer} data-testid="error-container">
        <Grid container justifyContent="center" alignItems="center" className={styles.Error}>
          <Grid item colLg={6} colMd={5} colSm={6}>
            <H2 roboto>Something went wrong!</H2>
            <div className={styles.ErrorDescription}>
              <Paragraph>
                We apologize for the inconvenience. Please refresh the page and if the problem persists, check back later.
              </Paragraph>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
};

export default ErrorMessageBody;
